import { Component, ojs, app } from "modular-openscriptjs";
import GlobalModal from "../GlobalModal";
import OffCanvasNav from "../OffCanvasNav";
import ProfileCanvas from "./ProfileCanvas";
import { gc, uc } from "../../ojs.contexts";
import ViewProduct from "../Views/ViewProduct";
import Offcanvas from "../Blocks/Offcanvas";
import DepositAiCreditForm from "../Forms/DepositAiCreditForm";
import Confirmation from "../Confirmation";
import DeliveryAddressOffcanvas from "./DeliveryAddressOffcanvas";
import DeliveryAddressForm from "../Forms/DeliveryAddressForm";
import AddressPickerForm from "../Forms/AddressPickerForm";
import DeliveryRequestForm from "../Forms/DeliveryRequestForm";
import DeliveryAddressList from "../Modals/DeliveryAddressList";
import MainActionForm from "../Forms/MainActionForm";
import SubscriptionPlansForm from "../Forms/SubscriptionPlansForm";
import DepositCapaForm from "../Forms/DepositCapaForm";
import TransferCapaForm from "../Forms/TransferCapaForm";
import CancelOrderForm from "../Forms/CancelOrderForm";
import ReviewForm from "../Forms/ReviewForm";
import AddProductForm from "../Forms/AddProductForm";
import ProductExtractionProgressForm from "../Forms/ProductExtractionProgressForm";
import QRScanForm from "../Forms/QRScanForm";
import OrderRepeatForm from "../Forms/OrderRepeatForm";
import TermsAndConditionsForm from "../Forms/TermsAndConditionsForm";
import AppReviewPromptModal from "../Modals/AppReviewPromptModal";
import BusinessRatingModal from "../Modals/BusinessRatingModal";
import VoiceOrderCallModal from "../Modals/VoiceOrderCallModal";
import FeatureAnnouncementModal from "../Modals/FeatureAnnouncementModal";
import AddToHomescreenModal from "../Modals/AddToHomescreenModal";
import LoginModal from "../Modals/LoginModal";

const h = app("h");

ojs(
    OffCanvasNav,
    GlobalModal,
    ProfileCanvas,
    Offcanvas,
    DepositAiCreditForm,
    ViewProduct,
    Confirmation,
    DeliveryAddressForm,
    AddressPickerForm,
    DeliveryRequestForm,
    DeliveryAddressList,
    MainActionForm,
    SubscriptionPlansForm,
    DepositCapaForm,
    TransferCapaForm,
    CancelOrderForm,
    ReviewForm,
    AddProductForm,
    ProductExtractionProgressForm,
    OrderRepeatForm,
    TermsAndConditionsForm,
    AppReviewPromptModal,
    BusinessRatingModal,
    VoiceOrderCallModal,
    FeatureAnnouncementModal,
    AddToHomescreenModal,
    LoginModal,
);

export default class AppOffCanvas extends Component {
    render(...args) {
        return h.wrapper(
            h.GlobalModal(),
            h.ProfileCanvas(),
            h.ActionsCanvas(),

            h.OffCanvasNav(gc.auth, uc.permissions, uc.roles),
            h.ReferFriend(),
            h.ViewProduct(),
            h.Confirmation(),
            h.DeliveryAddressForm(),
            h.AddressPickerForm(),
            h.DeliveryRequestForm(),
            h.DeliveryAddressList(),
            h.MainActionForm(),
            h.SubscriptionPlansForm(),
            h.DepositCapaForm(),
            h.TransferCapaForm(),
            h.CancelOrderForm(),
            h.ReviewForm(),
            h.AddProductForm(),
            h.ProductExtractionProgressForm(),
            h.DepositAiCreditForm(),
            h.OrderRepeatForm(),
            h.TermsAndConditionsForm(),
            h.AppReviewPromptModal(),
            h.BusinessRatingModal(),
            h.VoiceOrderCallModal(),
            h.FeatureAnnouncementModal(),
            h.AddToHomescreenModal(),
            h.LoginModal(),
        );
    }

    cleanUp() {
        super.cleanUp();
        let markup = this.markup();

        for (let elem of markup) {
            disposeBootstrapTree(elem);
        }
    }
}

ojs(AppOffCanvas);
